module.exports = __webpack_public_path__ + "img/volume-on.830b0fe8.svg";